import React, { useState } from "react";

const faqData = [
  {
    question: "Alışveriş etdim ama məhsul mənə çatmadı?",
    answer:
      "Whatsapp nömrəmizə bildirin. Əməkdaşlarımız sizinlə əlaqə qurub problemi aradan qaldıracaq.",
  },
  {
    question: "Kontur ilə ödəniş edə bilərəm?",
    answer: "Kontur ilə ödəniş mümkün deyil.",
  },
  {
    question: "Kredit kartı ilə ödəniş edə bilərəm?",
    answer:
      "Kredit kartı ilə ödəniş etmək mümkün deyil. Köçürmə yolları ilə ödəniş edə bilərsiniz.",
  },
  {
    question: "Terminal qəbz vermədikdə nə etməliyəm?",
    answer:
      "Terminal qəbz vermədikdə həmin şirkətin müştəri xidmətinə yığaraq elektron qəbz alın və müştəri xidmətinə o qəbzi göndərin. Balansınızı artıracaqlar.",
  },
  {
    question: "İş qrafikiniz necədir?",
    answer: "İş qrafikimiz hər gün saat 11:00 - 04:00 arasıdır.",
  },
];

const Support = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <main
      className="
        min-h-screen w-full overflow-x-hidden
        bg-[#f6f7fb] text-slate-900
        transition-colors duration-300
        dark:bg-[#05030a] dark:text-white
      "
    >
      {/* =====================================================
          HERO
      ===================================================== */}
      <section
        className="
          relative flex min-h-[200px]
          items-center justify-center
          overflow-hidden
          border-b border-slate-200
          bg-slate-100
          dark:border-white/[0.05]
          dark:bg-[#06040d]
          sm:min-h-[235px]
          md:min-h-[275px]
        "
      >
        {/* Grid */}
        <div
          className="absolute inset-0 opacity-40 dark:opacity-[0.18]"
          style={{
            backgroundImage: `
              linear-gradient(rgba(139,92,246,0.10) 1px, transparent 1px),
              linear-gradient(90deg, rgba(34,211,238,0.10) 1px, transparent 1px)
            `,
            backgroundSize: "30px 30px",
          }}
        />

        {/* Purple glow */}
        <div
          className="
            absolute -left-10 top-1/2
            h-36 w-36
            -translate-y-1/2
            rounded-full
            bg-purple-500/15
            blur-[75px]
            dark:bg-purple-600/20
            sm:h-52 sm:w-52
          "
        />

        {/* Cyan glow */}
        <div
          className="
            absolute -right-10 bottom-0
            h-36 w-36
            rounded-full
            bg-cyan-400/10
            blur-[75px]
            dark:bg-cyan-500/15
            sm:h-52 sm:w-52
          "
        />

        {/* Center glow */}
        <div
          className="
            absolute left-1/2 top-1/2
            h-24 w-24
            -translate-x-1/2
            -translate-y-1/2
            rounded-full
            bg-[#d6b36a]/10
            blur-[60px]
            sm:h-36 sm:w-36
          "
        />

        {/* Circle 1 */}
        <div
          className="
            absolute left-1/2 top-1/2
            h-[175px] w-[175px]
            -translate-x-1/2
            -translate-y-1/2
            rounded-full
            border border-purple-500/10
            dark:border-purple-400/[0.08]
            sm:h-[240px] sm:w-[240px]
          "
        />

        {/* Circle 2 */}
        <div
          className="
            absolute left-1/2 top-1/2
            h-[115px] w-[115px]
            -translate-x-1/2
            -translate-y-1/2
            rounded-full
            border border-cyan-400/10
            dark:border-cyan-400/[0.08]
            sm:h-[165px] sm:w-[165px]
          "
        />

        {/* Side lines */}
        <div className="absolute left-0 top-1/2 h-px w-[22%] bg-gradient-to-r from-transparent to-purple-500/20" />
        <div className="absolute right-0 top-1/2 h-px w-[22%] bg-gradient-to-l from-transparent to-cyan-500/20" />

        {/* Hero content */}
        <div className="relative z-10 px-4 text-center">
          {/* Badge */}
          <div
            className="
              mx-auto mb-3
              inline-flex items-center gap-2
              rounded-full
              border border-[#d6b36a]/20
              bg-white/70
              px-3 py-1
              text-[9px]
              font-bold
              uppercase
              tracking-[0.28em]
              text-[#9b7836]
              backdrop-blur-md
              dark:border-[#d6b36a]/20
              dark:bg-[#0d0915]/80
              dark:text-[#d6b36a]
              sm:px-4 sm:py-1.5
              sm:text-[10px]
            "
          >
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 shadow-[0_0_10px_rgba(52,211,153,0.8)]" />
            FF QADİR SUPPORT
          </div>

          {/* Title */}
          <h1
            className="
              text-3xl
              font-black
              tracking-tight
              text-slate-900
              dark:text-white
              sm:text-4xl
              md:text-5xl
            "
          >
            Sənə{" "}
            <span
              className="
                bg-gradient-to-r
                from-purple-500
                via-fuchsia-500
                to-cyan-400
                bg-clip-text
                text-transparent
              "
            >
              necə kömək
            </span>{" "}
            edə bilərik?
          </h1>

          {/* Divider */}
          <div className="mx-auto mt-3 flex items-center justify-center gap-2">
            <div className="h-px w-7 bg-gradient-to-r from-transparent to-[#d6b36a]" />

            <div
              className="
                h-1.5 w-1.5 rotate-45
                bg-[#d6b36a]
                shadow-[0_0_10px_rgba(214,179,106,0.6)]
              "
            />

            <div className="h-px w-7 bg-gradient-to-l from-transparent to-[#d6b36a]" />
          </div>

          <p
            className="
              mx-auto mt-3 max-w-md
              text-[11px]
              leading-5
              text-slate-500
              dark:text-white/40
              sm:text-sm
            "
          >
            Ən çox verilən sualların cavablarını burada tapa bilərsən.
          </p>
        </div>

        {/* Bottom fade */}
        <div
          className="
            absolute bottom-0 left-0 right-0
            h-12
            bg-gradient-to-t
            from-[#f6f7fb]
            to-transparent
            dark:from-[#05030a]
          "
        />
      </section>

      {/* =====================================================
          FAQ SECTION
      ===================================================== */}
      <section
        className="
          relative mx-auto w-full max-w-4xl
          px-3 py-7
          sm:px-5 sm:py-10
          md:px-7 md:py-14
        "
      >
        {/* Ambient glow */}
        <div
          className="
            pointer-events-none
            absolute left-0 top-[20%]
            h-40 w-40
            rounded-full
            bg-purple-500/5
            blur-[80px]
            dark:bg-purple-600/10
          "
        />

        <div
          className="
            pointer-events-none
            absolute bottom-[10%] right-0
            h-40 w-40
            rounded-full
            bg-cyan-500/5
            blur-[80px]
            dark:bg-cyan-500/10
          "
        />

        {/* Section heading */}
        <div className="relative z-10 mb-6 text-center sm:mb-8">
          <div
            className="
              mx-auto mb-2
              inline-flex
              items-center gap-2
              rounded-full
              border border-purple-500/15
              bg-purple-500/5
              px-3 py-1
              text-[9px]
              font-bold
              uppercase
              tracking-[0.2em]
              text-purple-600
              dark:border-purple-500/20
              dark:bg-purple-500/5
              dark:text-purple-300
            "
          >
            <span>✦</span>
            FAQ
          </div>

          <h2
            className="
              text-xl
              font-black
              text-slate-900
              dark:text-white
              sm:text-2xl
              md:text-3xl
            "
          >
            Suallar və cavabları
          </h2>

          <p
            className="
              mx-auto mt-2
              max-w-md
              text-[11px]
              leading-5
              text-slate-500
              dark:text-white/35
              sm:text-sm
            "
          >
            Sizi ən çox maraqlandıran sualları cavabladıq.
          </p>
        </div>

        {/* FAQ list */}
        <div className="relative z-10 space-y-2.5 sm:space-y-3">
          {faqData.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={faq.question}
                className={`
                  group
                  overflow-hidden
                  rounded-[16px]
                  border
                  transition-all
                  duration-300
                  sm:rounded-[19px]

                  ${
                    isOpen
                      ? `
                        border-purple-500/35
                        bg-purple-50/70
                        shadow-[0_12px_35px_rgba(139,92,246,0.10)]
                        dark:border-purple-500/30
                        dark:bg-[#0c0815]
                        dark:shadow-[0_15px_45px_rgba(139,92,246,0.10)]
                      `
                      : `
                        border-slate-200
                        bg-white/70
                        hover:border-purple-300/50
                        hover:bg-white
                        dark:border-white/[0.05]
                        dark:bg-[#090611]
                        dark:hover:border-purple-500/20
                        dark:hover:bg-[#0c0815]
                      `
                  }
                `}
              >
                {/* Top neon line when open */}
                <div
                  className={`
                    h-px w-full
                    transition-all duration-300
                    ${
                      isOpen
                        ? "bg-gradient-to-r from-transparent via-purple-500 to-transparent opacity-100"
                        : "bg-gradient-to-r from-transparent via-white/0 to-transparent opacity-0"
                    }
                  `}
                />

                {/* Question button */}
                <button
                  type="button"
                  onClick={() => toggleFaq(index)}
                  aria-expanded={isOpen}
                  className="
                    flex
                    w-full
                    items-center
                    gap-2.5
                    px-3
                    py-3
                    text-left
                    sm:gap-3
                    sm:px-4
                    sm:py-4
                    md:px-5
                  "
                >
                  {/* Number */}
                  <span
                    className={`
                      flex
                      h-8 w-8
                      shrink-0
                      items-center
                      justify-center
                      rounded-[10px]
                      border
                      text-[10px]
                      font-black
                      transition-all
                      duration-300
                      sm:h-9 sm:w-9
                      sm:rounded-xl
                      sm:text-xs

                      ${
                        isOpen
                          ? `
                            border-purple-500/40
                            bg-purple-500/10
                            text-purple-600
                            dark:border-purple-500/40
                            dark:bg-purple-500/10
                            dark:text-purple-300
                          `
                          : `
                            border-[#d6b36a]/20
                            bg-[#d6b36a]/5
                            text-[#a17d37]
                            dark:border-[#d6b36a]/20
                            dark:bg-[#d6b36a]/5
                            dark:text-[#d6b36a]
                          `
                      }
                    `}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  {/* Question */}
                  <span
                    className="
                      flex-1
                      pr-1
                      text-[12px]
                      font-bold
                      leading-5
                      text-slate-800
                      dark:text-white
                      sm:text-sm
                      md:text-[15px]
                    "
                  >
                    {faq.question}
                  </span>

                  {/* Plus / Minus */}
                  <span
                    className={`
                      flex
                      h-8 w-8
                      shrink-0
                      items-center
                      justify-center
                      rounded-[10px]
                      text-lg
                      font-light
                      transition-all
                      duration-300
                      sm:h-9 sm:w-9
                      sm:rounded-xl

                      ${
                        isOpen
                          ? `
                            rotate-180
                            bg-purple-500/10
                            text-purple-600
                            dark:bg-purple-500/10
                            dark:text-purple-300
                          `
                          : `
                            bg-purple-500/5
                            text-purple-500
                            dark:bg-purple-500/10
                            dark:text-purple-400
                          `
                      }
                    `}
                  >
                    {isOpen ? "−" : "+"}
                  </span>
                </button>

                {/* Answer */}
                <div
                  className={`
                    grid
                    transition-all
                    duration-300
                    ease-in-out
                    ${
                      isOpen
                        ? "grid-rows-[1fr] opacity-100"
                        : "grid-rows-[0fr] opacity-0"
                    }
                  `}
                >
                  <div className="overflow-hidden">
                    <div
                      className="
                        border-t
                        border-slate-200
                        px-3
                        pb-3.5
                        pt-3
                        dark:border-white/[0.05]
                        sm:px-4
                        sm:pb-4
                        sm:pt-3.5
                        md:px-5
                      "
                    >
                      <div
                        className="
                          relative
                          overflow-hidden
                          rounded-xl
                          border
                          border-purple-500/10
                          bg-purple-50/50
                          px-3
                          py-3
                          dark:border-purple-500/10
                          dark:bg-[#08050e]
                          sm:px-4
                          sm:py-3.5
                        "
                      >
                        {/* Answer glow */}
                        <div
                          className="
                            absolute -right-8 -top-8
                            h-20 w-20
                            rounded-full
                            bg-purple-500/5
                            blur-2xl
                            dark:bg-purple-500/10
                          "
                        />

                        <div className="relative">
                          <div className="mb-1.5 flex items-center gap-1.5">
                            <span className="text-[9px] text-purple-500 dark:text-purple-400">
                              ✦
                            </span>

                            <span
                              className="
                                text-[9px]
                                font-bold
                                uppercase
                                tracking-[0.15em]
                                text-purple-600
                                dark:text-purple-300
                              "
                            >
                              Cavab
                            </span>
                          </div>

                          <p
                            className="
                              text-[11px]
                              leading-5
                              text-slate-600
                              dark:text-white/55
                              sm:text-xs
                              sm:leading-6
                              md:text-sm
                            "
                          >
                            {faq.answer}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* =====================================================
            BOTTOM SUPPORT CARD
        ===================================================== */}
        <div
          className="
            relative z-10
            mx-auto mt-6
            max-w-xl
            overflow-hidden
            rounded-[17px]
            border border-slate-200
            bg-white/70
            px-4 py-4
            text-center
            shadow-[0_15px_40px_rgba(15,23,42,0.05)]
            backdrop-blur-xl
            dark:border-white/[0.05]
            dark:bg-[#090611]
            dark:shadow-[0_20px_50px_rgba(0,0,0,0.4)]
            sm:mt-8
            sm:rounded-[20px]
            sm:px-5
            sm:py-5
          "
        >
          {/* Glow */}
          <div
            className="
              absolute left-1/2 top-0
              h-16 w-36
              -translate-x-1/2
              rounded-full
              bg-purple-500/5
              blur-3xl
              dark:bg-purple-500/10
            "
          />

          <div className="relative">
            <div
              className="
                mx-auto
                flex h-9 w-9
                items-center justify-center
                rounded-xl
                border border-[#d6b36a]/20
                bg-[#d6b36a]/10
                text-sm
              "
            >
              💬
            </div>

            <h3
              className="
                mt-2
                text-sm
                font-bold
                text-slate-900
                dark:text-white
              "
            >
              Cavabını tapa bilmədin?
            </h3>

            <p
              className="
                mt-1
                text-[10px]
                leading-4
                text-slate-500
                dark:text-white/35
              "
            >
              Bizimlə əlaqə saxla, sənə kömək edək.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Support;